import {
    takeEvery, put, call,
} from 'redux-saga/effects';
import { showMessage, startLoading, stopLoading } from '../../theme/constants/actionConstants';
import * as actions from '../constants/actionConstants';
import { ADMIN_MANAGER_GET } from '../constants/actionTypes';
import myAxios from '../../constants/myAxios';


export function* adminUserWatcher() {
    yield takeEvery(ADMIN_MANAGER_GET, adminUserWorker);
}

function* adminUserWorker(action) {
    yield put(startLoading());
    try {
        const payload = yield call(myAxios, '/users/', 'get');
        yield put(actions.managerListSuccess('managers', payload.data.data));
        yield put(stopLoading());
    } catch (error) {
        let message = '';
        error.response && error.response.status >= 500 ? message = 'Server error' : message = 'Invalid credantials';
        yield put(actions.adminFail('managers', error.response));
        yield put(showMessage({
            message,
            variant: 'error',
        }));
        yield put(stopLoading());
    }
}
